import { NUMBER_FORMAT } from "@/pages/CreatorAnalytics/constants";

export const formatNumber = (value: number): string => {
  if (value >= NUMBER_FORMAT.MILLION) {
    return `${(value / NUMBER_FORMAT.MILLION).toFixed(1)}M`;
  }
  if (value >= NUMBER_FORMAT.THOUSAND) {
    return `${(value / NUMBER_FORMAT.THOUSAND).toFixed(1)}K`;
  }
  return value.toLocaleString();
};
